import React, { Ref, useEffect, useRef, useState } from 'react';
import { Polygon } from 'react-leaflet';
import { filterPolygonPointsByDistance } from '../../../../../../core/utils/map.utils';
import { useSelector } from 'react-redux';
import {
    multiPolygonEditedIDState,
    isPolygonDragActiveState,
    isUsingMeasuringToolState,
    singlePolygonCoordsState,
    mapTileUrlState,
    isSlopeServiceActiveState,
} from '../../../../../../app/redux/retrievers/retrievers';
import { theme } from '../../../../../../core/theme/theme';
import { Polygon as PolygonType } from 'leaflet';
import PolygonBreakpoints from '../../../../components/Polygons/PolygonBreakpoints/PolygonBreakpoints';
import SlopeServiceLayer from './SlopeServiceLayer/SlopeServiceLayer';

interface SinglePolygonProps {
    measuringToolDrawn?: boolean;
}

const SinglePolygon: React.FC<SinglePolygonProps> = ({ measuringToolDrawn }) => {
    const singlePolygonRef = useRef(null) as Ref<PolygonType<any>>;

    const mapTileUrl = useSelector(mapTileUrlState);
    const singlePolygonCoords = useSelector(singlePolygonCoordsState);
    const isPolygonDragActive = useSelector(isPolygonDragActiveState);
    const filteredSinglePolygonCoords = filterPolygonPointsByDistance(singlePolygonCoords);
    const isUsingMeasuringTool = useSelector(isUsingMeasuringToolState);
    const isSlopeServiceActive = useSelector(isSlopeServiceActiveState);
    const [polygonKey, setPolygonKey] = useState(0);

    useEffect(() => {
        /*generate new key for polygon component each time coords are updated to fix editing bug*/
        setPolygonKey(polygonKey + 1 * Math.random());
    }, [singlePolygonCoords, mapTileUrl, isPolygonDragActive, measuringToolDrawn, isUsingMeasuringTool]);

    if (filteredSinglePolygonCoords.length < 3) {
        return null;
    }
    return (
        <>
            <Polygon
                ref={singlePolygonRef}
                key={polygonKey}
                positions={filteredSinglePolygonCoords}
                color={theme.colors.single_polygon_color}
                fillOpacity={0}
                fillColor={theme.colors.single_polygon_color}
                eventHandlers={{}}
                // pathOptions={{ weight: 1 }}
            >
                {isSlopeServiceActive && <SlopeServiceLayer polygonCoords={singlePolygonCoords} />}
            </Polygon>
        </>
    );
};

export default SinglePolygon;
